import { CenteredLayout } from "@/layouts/CenteredLayout";
import LogoIcon from "@/svg/brand/cohesive-logo-icon.svg?react";
import { motion } from "framer-motion";
import type { FC } from "react";

const MaintenancePage: FC = function () {
  return (
    <>
      <title>Maintenance</title>
      <CenteredLayout maxWidth="md">
        <motion.div className="space-y-8">
          <div className="space-y-6 text-center">
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                type: "spring",
                stiffness: 100,
                damping: 15,
              }}
              className="flex justify-center"
            >
              <LogoIcon width="64" height="64" />
            </motion.div>

            <motion.h1
              className="text-3xl font-bold text-foreground sm:text-5xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.2,
                duration: 0.4,
                ease: "easeOut",
              }}
            >
              Under maintenance
            </motion.h1>

            <motion.p
              className="mx-auto max-w-2xl px-4 text-base font-medium tracking-tight text-muted-foreground sm:text-xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.4,
                duration: 0.4,
                ease: "easeOut",
              }}
            >
              Sorry for the inconvenience — we&apos;re performing scheduled
              maintenance and will be back shortly.
            </motion.p>
          </div>
        </motion.div>
      </CenteredLayout>
    </>
  );
};

export default MaintenancePage;
